var map = {
	"./bootstrap.svg": "a1l4",
	"./confluence.svg": "rWIS",
	"./docker.svg": "j5BD",
	"./git.svg": "KLpK",
	"./github.svg": "yUNQ",
	"./java.svg": "MOtX",
	"./javascript.svg": "mDdD",
	"./jira.svg": "YwqJ",
	"./logo.svg": "zoAU",
	"./node-dot-js.svg": "iIcs",
	"./pandas.svg": "C6pt",
	"./python.svg": "ntaN",
	"./react.svg": "6DUQ",
	"./redux.svg": "jhUP",
	"./sass.svg": "Iedp",
	"./slack.svg": "mORn",
	"./spring.svg": "GKrM"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "X5+2";